import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

import { useRootStore } from "store";

import "./ActivateUser.scss";

export default function ActivateUser() {
  const { key } = useParams();
  const navigate = useNavigate();

  const {validateToken} = useRootStore((state) => state.user)

  useEffect(() => {
    if (key) {
     validateToken(key);
      return () => {
        navigate("/");
      };
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, validateToken]);

  return <div className="activateUserWrapper">Verifierar länk...</div>;
}
